<customer-header-template [customer]="customer"></customer-header-template>

<div id="contactcards">
  @for (contact of contacts; track contact; let index = $index) {
    <div class="contactcard" (click)="open(index, contact)">
      <div style="align-self: flex-start;">
        <div class="row">
          <div class="col-sm-12">
            <h4>{{ contact.title }} {{ contact.first_name }} {{ contact.last_name}}</h4>
          </div>
        </div>
        @if (contact.departments.length > 0) {
          <div class="row">
            <div class="col-sm-12">
              {{ contact.departments|JoinStringPipe }}
            </div>
          </div>
        }
        @if (contact.position) {
          <div class="row">
            <div class="col-sm-12">
              {{ contact.position }}
            </div>
          </div>
        }
      </div>
      <div style="align-self: flex-end;">
        @if (contact.phone) {
          <div class="row">
            <div class="col-sm-2">Telefon:</div>
            <div class="col-sm-10">{{ contact.phone }}</div>
          </div>
        }
        @if (contact.mobile) {
          <div class="row">
            <div class="col-sm-2">Mobil:</div>
            <div class="col-sm-10">{{ contact.mobile }}</div>
          </div>
        }
        @if (contact.fax) {
          <div class="row">
            <div class="col-sm-2">Fax:</div>
            <div class="col-sm-10">{{ contact.fax }}</div>
          </div>
        }
        @if (contact.mail) {
          <div class="row">
            <div class="col-sm-2">E-Mail:</div>
            <div class="col-sm-10">{{ contact.mail }}</div>
          </div>
        }
      </div>
      @if (contact.note) {
        <div style="align-self: flex-end;">
          <div class="row">
            <div class="col-sm-12"><strong>Hinweis:</strong></div>
          </div>
          <div class="row">
            <div class="col-sm-12"><strong>{{contact.note}}</strong></div>
          </div>
        </div>
      }
    </div>
  }

</div>
